import { useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { isDemoMode } from "../../config/demoMode";
import { SALES_LANDING_PATH } from "../../config/marketing";
import "./DemoBanner.css";

function DemoBanner() {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  if (!isDemoMode()) return null;

  const path = location.pathname;
  const onPublicLanding =
    !isAuthenticated && path === SALES_LANDING_PATH;
  if (onPublicLanding) return null;

  return (
    <div className="demo-banner" role="status">
      نسخة تجريبية معزولة — بيانات وهمية منفصلة عن النظام الحقيقي
    </div>
  );
}

export default DemoBanner;
